// Default Variable Values

var baseURL = "https://ps-whi-stage.azurewebsites.net/vehicles";
var yearDD = document.getElementById('ymm_year');
var makeDD = document.getElementById('ymm_make');
var modelDD = document.getElementById('ymm_model');
var trimDD = document.getElementById('ymm_trim');
var engineDD = document.getElementById('ymm_engine');
var baseVehicleID=0;
var maxOrderQty = 10;

// variables that need to be set bu Liquid page (pre-page-load). These will be checked on page load and will trigger required functions
var collapseFitment = false;
var fitmentPDP = false;

var storePageURL = "https://partsource.myshopify.com/apps/store-locator/";

var psBG = '#E32619';

var isMobile = false;

var desktopLowerLimit = 1015;

// holds stock qty for all stores
//let tempStoreQty = [];
  

// Helper functions
function byID(id){
	return document.getElementById(id);
}

$('#pdpOptions').on('change', function() {
  $('#part_availability').html('Updating ...');
  setTimeout(function(){
  	var sku = $('#SKU_val').children().eq(1).html();
    getAvailability(sku,true);
  }, 2000);
});

function setMyVehicle(redirectType){


  if (redirectType == "browse"){ 
    // Takes you to the search page (side nav) and passing the vehicle ID as the ONLY search term
    setTimeout(function() {
        window.location = "https://partsource.myshopify.com/search?q=v" + getCookie("vehicleID");
    }, 2000);
  }
  else if(redirectType == "QR"){
    checkForRedirectURL();
  }
  else if (getCookie("temp_vid") != ""){
  var vehicleTitle = $('#ymm_year').find('option:selected').text().trim() + " " + $('#ymm_make').find('option:selected').text().trim() + " " + $('#ymm_model').find('option:selected').text().trim() + " (" + $('#ymm_trim').find('option:selected').text().trim() + ")";
	var yearSelected, makeSelected, modelSelected;
    
    var vehicleDescriptionFull = vehicleTitle + " Engine: " + $('#ymm_engine').find('option:selected').text().trim();
    var vehicleEngine = $('#ymm_engine').find('option:selected').text().trim();
    
    yearSelected = $('#ymm_year').find('option:selected').text().trim();
    makeSelected = $('#ymm_make').find('option:selected').text().trim();
    modelSelected = $('#ymm_model').find('option:selected').text().trim();
    
    

    // set my vehicle in Cookies
    setCookie("vehicleID",getCookie("temp_vid"),30);
    setCookie("vehicleDescription",vehicleTitle,30);
    setCookie("vehicleDescriptionFull",vehicleDescriptionFull,30);

    // reset drop down options
    yearDD.selectedIndex =0;
    makeDD.selectedIndex =0;
    // trigger function 'makeChanged' to reset other options
    makeChanged();

    //showYMM_selected();


    // ADDED BY SOUND PRESS
    // Set a Shopify Cart Attribute with the vehicleToEngineConfigId
    // PS : Disable for IE11 - Need an alternative
    $.ajax({
      type: "POST",
      url: '/cart.js',
        data: {"attributes[vehicleId]": getCookie("vehicleID"),
             "attributes[vehicleDescription]": vehicleTitle,
             "attributes[vehicleEngine]": vehicleEngine,
             "attributes[vehicleDescriptionFull]": vehicleDescriptionFull
            },
      success: function(data){
        var url = window.location + "?utm_year=" + yearSelected + "&utm_make=" + makeSelected + "&utm_model=" + modelSelected
        // use this code when a landing page is available
        if (redirectType == "set"){
        	location.reload();
        }
        else if (redirectType == "setandBrowse"){ 
          // Takes you to the search page (side nav) and passing the vehicle ID as the ONLY search term
          setTimeout(function() {
  				window.location = "https://partsource.myshopify.com/search?q=v" + getCookie("vehicleID");
			}, 2000);
        }
        else if (redirectType == "set_and_QR" ){ // All queries from the 'Confirm your vehicle page will land in this condition'
            checkForRedirectURL();
        }
        else{
        	//window.location = "https://partsource.ca/pages/browse-products";
          setTimeout(function() {
  				window.location = "https://partsource.myshopify.com/search?q=v" + getCookie("vehicleID");
			}, 1000);
            
          	
        }
      },
      dataType: 'json'
    });
    
  }
}

function checkForRedirectURL(){
  const queryString = window.location.search;
  const parameters = new URLSearchParams(queryString);
  
  // Takes you to the search page (side nav) and passing the vehicle ID as well as the redirect URL with the related search terms
  
  if (parameters.has('redirectURL')){
      setTimeout(function() {
        const uri = parameters.get('redirectURL');
        console.log(uri+ "&q=v" + getCookie("vehicleID"))
        //const encoded = encodeURL(uri);
        //console.log(encoded);
        window.location.href = parameters.get('redirectURL') + "&q=v" + getCookie("vehicleID");
    }, 1000);
  }
  else{
  // Since there's no redirect URL identified, the defaut is to tkae the user to the QR categories landing page
    setTimeout(function() {
        window.location = "https://partsource.myshopify.com/pages/qr-browse-products";
    }, 1000);
  
  }
}

function removeMyVehicle(deleteCookie){
  if (deleteCookie == true){
  	setCookie("vehicleID","",365);
  	setCookie("temp_vid","",365);
  	setCookie("vehicleDescription","",365);
    setCookie("vehicleDescriptionFull","",365);
    
	// Set a Shopify Cart Attribute with the vehicleToEngineConfigId      
    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[vehicleId]": null,
             "attributes[vehicleDescription]": null,
             "attributes[vehicleDescriptionFull]": null            
            },
      success: function(data){
        window.location.reload(); 
      },
      dataType: 'json'
    });
    window.location.reload()
  }
  else{
    showYMM_options();
  }
}

function showYMM_selected(isPageLoad){
  if (isMobile){
    //$('#YMM_tab').html(getCookie("vehicleDescription") + " Selected &nbsp; <button class='ymm_yellow_button baseControl' style='max-width:80px; border:none; margin:0px; padding:0px; max-height:25px; font-size:0.8em;'>Change</span>" );
    $('#YMM_options').slideUp("slow");
  }
  else{
    // set 'myVehicle' to visible
    //$('#selectedVehicle').html("<span style=''>My Vehicle | </span>" + getCookie("vehicleDescription"));
    //$('#selectedVehicle').html("My Vehicle | " + getCookie("vehicleDescription"));

    $('#YMM_options').fadeOut("fast", function(){
      $('#YMM_selected').fadeIn("slow");
    });
  }
}

function showYMM_options(){
 // set YMM options to visible
  if (getCookie("vehicleID") == "" && (!isMobile)){
    $('#cancelYMM_Select').hide();
  }
  else{
    $('#cancelYMM_Select').show();
  }
  
  if (isMobile){
    //$('#YMM_tab').html("Select My Vehicle");
    $('#YMM_options').slideDown("slow");
  }
  else{
    $('#YMM_selected').fadeOut("fast", function(){
      $('#YMM_options').fadeIn("slow");
    });
  }

}

function copySKU(){
  var tempElement = document.createElement("input");
  tempElement.setAttribute("type", "text");
  tempElement.setAttribute("id", "tempElement");
  $("body").append(tempElement);

  var tempVal = $('#SKU_val').text()
  tempVal = tempVal.trim();
  tempVal = tempVal.substring(tempVal.length-7,tempVal.length);
  $('#tempElement').val(tempVal);
  var copyText =$("#tempElement");
  
  copyText.select();
  document.execCommand("Copy");
  tempElement.remove();
}

function focusYMM_selection(){
  
  $("#ymm_year").focus();
  $("#ymm_year").click();
}
  

function myPage_Load(){
  
  // 2026-08-21 : New function to watch if page contents on store lacator page have loaded
  watchStoreLocatorResults();

  // START Hide Secondary Search bar on search page with LEFT NAV
  
  //$( ".boost-pfs-filter-collection-header-wrapper" ).css( "border", "3px solid red" );
  //$( ".boost-pfs-filter-collection-header-wrapper" ).hide();
  
  // END Hide Secondary Search bar on search page with LEFT NAV
  
  
  
  // Helper Function to check element existance
  jQuery.fn.exists = function(){ return this.length > 0; }

  if(getCookie("vehicleID") != ""){
    
    if($('.categoryIcon').length){
      var href = "";
      $('.categoryIcon').each(function(){
          href = $(this).find('a').attr('href');

          $(this).find('a').attr('href', href+'+v' + getCookie('vehicleID') + '*')
      });

      //var href = $('.categoryIcon').find('a').attr('href');
      //$('.categoryIcon').find('a').attr('href', href+'+v' + getCookie('vehicleID') + '*')
    }
  }
  
  // determine if mobile device is being used
  isMobile = detectMobile();
  
   // Redirects for Retail and Commercial Flyers
  checkForRedirects();

  // Read email address (from query string) for email signup page
  if ($(location).attr('pathname').indexOf("email_signup") > 0 ){
    var parameter = "email=";
    var q = location.search;
    if (q.indexOf(parameter) > 0){
      var email = q.substring(q.indexOf(parameter) + parameter.length);
      $("input[name='email']").val(email);
    }
  }
  
  
  // YMM 
  // Remove YMM panel 'desktop view' whn using a mobile device
  
  if (isMobile){
  	$(".YMM_desktop").html("");
  }else{
  	$(".YMM_mobile").html("");
  }
  
  // Load YMM - Make
  
  loadMake();
  
  // Set my store information (if available)
  setStoreFromCookies();
  
  // changes required for store locator page
  if ($(location).attr('pathname').indexOf("locator") > 0 ){
    
    //$.holdReady(true);
    
    
    //var sBtn = document.evaluate('//*[@id="col-main"]/div[2]/button', document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    var sBtn = document.getElementById('submitBtn');

    setTimeout(function() {
    
    $(sBtn).addClass("storeSearchButton");

    $(sBtn).click(function() {

        $.ajax({
            url: codeAddress(),
            success: function() {
                addStoreSelectorButton();
            }
        });

    });

}, 2000);

  	
    
    // Search box 'Enter key' event
    
    $('#submitBtn').on("keypress", function(e) {
        if (e.keyCode == 13) {
          //alert("Enter pressed");
            $.ajax({
           	url:codeAddress(),
           	success:function(){
            setTimeout(function() {
  				addStoreSelectorButton();
			}, 1000);
            }	
          });
          return false; // prevent the button click from happening
        }
	});
    
    
    // Search button click event
    
    $('#submitBtn').on("click", function(e) {
          //alert("Enter pressed");
            $.ajax({
           	url:codeAddress(),
           	success:function(){
            
            setTimeout(function() {
  				addStoreSelectorButton();
			}, 1000);
            }	
          });
          return false; // prevent the button click from happening
	}); 
    
  	//$('input[type="button"][value="Search"]').hide();
  
 
    
  	//$(".search_bar").append("<input type='button' value='Submit' onclick='customStoreSearch()' class='storeSearchButton' />");
    //var div = document.createElement("div");
    var btn = document.createElement("input");
    //$(div).append(btn);
    btn.type = "submit";
    btn.value = "Search";
    $(btn).addClass("storeSearchButton");
//$(btn).insertAfter("#limit");
    setTimeout(() => {
      addStoreSelectorButton();  
    }, 2000);  
    
    
    
    
    //$.holdReady(false);
    
  }
  if (collapseFitment == true){
    setCollapsibleFitment();
  }
  getPartFitment();
  
  
} // end function myPage_load




/*$('#psPageSearchTextBox').on('focusin', function(event) {
  	alert($('#psPageSearchTextBox').value());
    //event.stop(event); // suppress default click behavior, cancel the event

});



$('#psPageSearchTextBox').on('blur', function(event) {
  	event.preventDefault();
    //event.stop(event); // suppress default click behavior, cancel the event
});


$('#psHeaderSearchTextBox').on('blur', function(event) {
    event.preventDefault(); // suppress default click behavior, cancel the event

});
*/

/*function removeVIDfromSearch(){
  if($('#psPageSearchTextBox').length){
    var tempSearch = $('#psPageSearchTextBox').attr('value');
    var lastWord = tempSearch.split(" ").pop();
    if (lastWord.length ==7 && lastWord.charAt(0).toLowerCase() == 'v' ){
      $('#psPageSearchTextBox').attr('value',tempSearch.replace(' ' + lastWord,''));
      $('#psHeaderSearchTextBox').attr('value',tempSearch.replace(' ' + lastWord,''));
    }
  }
}*/


function delayShow(secs) {
  //setTimeout('jQuery("body").css("visibility","visible");', (secs * 1000));
  //setTimeout(showContent, (secs * 1000));
}

function showFlyer(){
  // if Flyer page, then "circ_div" div exists on the page. 
  // then display the flyer once page is loaded
  if ($('#circ_div').exists()){
    $("#circ_div").css("opacity", "1");
	//$('#circ_div').show();
    //$('#flyer_overlay').hide();
  }  
}

function checkForRedirects(){
  var retailFlyerLink = "/pages/flyer?hide=catalogue",
      commercialFlyerLink = "/pages/commercial-flyer?flyer_type_name=partsource-catalogue&hide=flyer";
  var url = window.location.href;
  //if (url.slice(-(retailFlyerLink.length)) == retailFlyerLink){
  if (url.indexOf("hide=catalogue") >=0){
  	showFlyer();
  }
  else if (url.slice(-12) == "/pages/flyer"){
    window.location.href = "https://www.partsource.ca/pages/flyer?hide=catalogue";
  }
  else if (url.indexOf("flyer_type_name=partsource-catalogue&hide=flyer") >=0){
    showFlyer();
  }
  else if (url.slice(-23) == "/pages/commercial-flyer"){
    window.location.href = "https://www.partsource.ca/pages/commercial-flyer?flyer_type_name=partsource-catalogue&hide=flyer";
  }
}


function getPartFitment(){
  
  if($("#temp_fitment").exists()){
  	var VIDs = $("#temp_fitment").text().trim();
  
    var myVID = getCookie("vehicleID");

    var delimeter = ""; // for mobile, we may require a line break, for desktop, use pipe '|'
    if (isMobile){
      delimeter = "<br />";
    }
    else{
      delimeter = " | ";
    }

    if (myVID != ""){
      if (VIDs.indexOf(myVID) >=0 ){
        $("#fitmentResult").html("<div class='baseBlock' ><span class='checkMark'> &#10004 </span> This part fits your vehicle " + delimeter +  getCookie("vehicleDescription") + "</div>");
      }
      else{
       $("#fitmentResult").html("<div class='baseBlock' ><span class='crossMark' style=''> &#10006 </span>This part does NOT fit your vehicle " + delimeter +  getCookie("vehicleDescription") + "</div>");
      }
    }
    // No vehicle Selected
    else{
      var html = "<div class='baseBlock' ><span class='crossMark' style='background-color:orange; font-weight:bold; '> ! </span>Please select a vehicle to ensure fitment &nbsp;</div>";
      //html = html + "<input type='button' class='baseButton' value='Select Vehicle' onclick='focusYMM_selection()' />";
      $("#fitmentResult").html(html);
    }
  }
  
}




function addStoreSelectorButton(){
  // Set styling for controls

  // add 'Select' button to each control

  //var br = document.createElement('br');

  var items = $('#addresses_list ul li').toArray();
  for (i = 0 ; i < items.length; i++){

      var div = document.createElement('div');

      var store = items[i].querySelector('.sl-store-name').innerHTML;
      var storeAddress = items[i].querySelector('.sl-layout-line--address').innerHTML;

      var storeCityProvPostal = items[i].querySelector('.sl-layout-line--city').innerHTML;
      
      var text = "Barrie, OntarioL4N 0W5, Canada";

      //var match = storeCityProvPostal.match(/^(.+?),\s*([A-Za-z]+)([A-Z]\d[A-Z]\s?\d[A-Z]\d),\s*(.+)$/);
      // 30th Anv code when the city and postal code had no space
      //  var match = storeCityProvPostal.match(/^(.*?),\s*(.+?)\s*([A-Z]\d[A-Z]\s?\d[A-Z]\d),\s*(.+)$/);

      // Sep 18 2026 code after the app developer fixed the space between the city and postal code
      var match = storeCityProvPostal.match(/^(.+?),\s*(.*?)\s+([A-Z]\d[A-Z]\s?\d[A-Z]\d),\s*(.+)$/i);
      
      if (match) {
          var storeCity = match[1].trim();
          var storeProvince = match[2].trim();
          var storePostal = match[3].trim();
          var storeCountry = match[4].trim();

    }


      // OLD CODE > var storeWebsite = items[i].firstChild.href;
      //var storeWebsite = items[i].querySelector('.store_website').innerHTML;

      // Sep 18 2026 - new query selector
      var storeWebsite = items[i].querySelector('.sl-address-website').innerHTML;
      

      var storeHours = "";
      var storePhone = "";

    
    var storeNum = store.substring(store.length - 3);
      var btn = document.createElement("input");

     if($( "#btn_PS" + storeNum ).length <= 0 ){
      // if condition STARTS
   

      btn.setAttribute('class','btnStoreSelect');
      btn.setAttribute('style','margin-top:30px;');

      btn.setAttribute('type','button');
      btn.setAttribute('value','Make This My Store');
      btn.setAttribute('id','btn_PS' + storeNum);
      btn.setAttribute("onclick","selectStore('" + store +  "','" + storeNum + "','" + storeAddress + "','" + storeCity + "','" + storeProvince + "','" + storePostal + "','"+ storePhone + "','" + storeWebsite + "','" + storeHours + "',false);");

      div.appendChild(btn);
      items[i].appendChild(div);
      // if condition ENDS
    }
  }
  // Disable selected store from cookies
  var storeFromCookies = getCookie('myStore');
  if (storeFromCookies != ""){
    var selectedStore = document.getElementById('btn_PS' + storeFromCookies.slice(-3));
    selectedStore.setAttribute('style','background-color:#bbb;margin-top:30px;');
    selectedStore.value = "Selected";
  }

}

function customStoreSearch(){
  // PS : Disable for IE11 - Need an alternative
    
  $.ajax({
     url:codeAddress(),
     success:function(){
     addStoreSelectorButton();
  }
  })
}


function detectMobile() {
   if(window.innerWidth <= desktopLowerLimit) {
     return true;
   } else {
     return false;
   }
}

function removeStore(){
  // Set Cart Attribute 'Store'
  
  setCookie("myStore","",365);
  setCookie("myStoreNum",0,365);
  setCookie("myStoreAddress","",365);
  setCookie("myStorePhone","",365);

  setStoreFromCookies();

  $.ajax({
    type: "POST",
    url: '/cart.js',
    data: {
      "attributes[storeNum]": null, 
      "attributes[store]": null, 
      "attributes[storeAddress]": null, 
      "attributes[storeCity]": null,
      "attributes[storeProvince]": null,
      "attributes[storePostal]": null,
      "attributes[storeWebsite]": null,
      "attributes[storePhone]": null

    },
    success: function(data){
      //var url = window.location + "?utm_year=" + yearSelected + "&utm_make=" + makeSelected + "&utm_model=" + modelSelected
      //window.location = url;

      
      location.reload(); 
    },
    dataType: 'json'
  });
  

}

var storeSelectorObserver = null;
var storeSelectorTimer = null;
 
function watchStoreLocatorResults() {

  var container = document.getElementById('addresses_list');
 
  if (!container) {

    setTimeout(watchStoreLocatorResults, 250);

    return;

  }
 
  function refreshStoreButtons() {

    clearTimeout(storeSelectorTimer);
 
    storeSelectorTimer = setTimeout(function () {

      addStoreSelectorButton();

    }, 250);

  }
 
  if (storeSelectorObserver) {

    storeSelectorObserver.disconnect();

  }
 
  storeSelectorObserver = new MutationObserver(function () {

    refreshStoreButtons();

  });
 
  storeSelectorObserver.observe(container, {

    childList: true,

    subtree: true

  });
 
  refreshStoreButtons();

}
 
function selectStore(store, storeNum, storeAddress, storeCity, storeProvince, storePostal, storePhone, storeWebsite, storeHours, reload){
  //var myStore = document.getElementById('myStore');
  
  //storeHours = storeHours.replace("<br>","")
  // Set Cart Attribute 'Store'
  $.ajax({
    type: "POST",
    url: '/cart.js',
    data: {
      "attributes[storeNum]": storeNum, 
      "attributes[store]": store, 
      "attributes[storeAddress]": storeAddress, 
      "attributes[storeCity]": storeCity,
      "attributes[storeProvince]": storeProvince,
      "attributes[storePostal]": storePostal,
      "attributes[storeWebsite]": storeWebsite,
      "attributes[storePhone]": storePhone,
      "attributes[storeHours]": storeHours,
      "attributes[invPO]": "Online Order #",
      "attributes[invMemo]": "Call Cust for Pickup",
      "attributes[invNote]": "Confirm Fitment With Customer"
    },
    success: function(data){
      
      	setCookie('myStore',store,365); // expires in 365 days
        setCookie('myStoreAddress',storeAddress,365); // expires in 365 days
        setCookie('myStorePhone',storePhone,365); // expires in 365 days
      	setCookie('myStoreHours',storeHours,365); // expires in 365 days

     	setStoreFromCookies();
  
        // Disable 'selected' button, and enable other 'Select' buttons

        var redirectURL = getCookie('redirectURL') ;
        if (redirectURL !=""){
          setCookie('redirectURL','')
          setTimeout(function() {
  				window.location.href = redirectURL;
			}, 1000);
          
          //window.history.back();
        }
        else{
          var items = $('#addresses_list ul li');
          for (i = 0 ; i < items.length; i++){
            var thisStore = items[i].querySelector('.btnStoreSelect');
            thisStore.setAttribute('style','background-color:' + psBG + ';');
            thisStore.value = "Make This My Store";
          }

          var selectedStore = document.getElementById('btn_PS' + storeNum);
          selectedStore.setAttribute('style','background-color:#bbb;');
          selectedStore.value = "Selected";
          if (reload){
          	location.reload();
          }
        }

    },
    dataType: 'json'
  });
  
}

function setStoreFromCookies(){
  /*
  var storeFromCookies = getCookie('myStore');
  if (storeFromCookies != ""){
    try{
	//var innerHTML = "<img src='" + closeImage + "' class='desktop_clearStore' onclick='clearStore()' alt='Clear Store Selection' />";
    
      var storeInfo, btn, innerHTML;
      
      storeInfo = "<span style='font-weight:bold;'>" + getCookie('myStore').slice(11,-8) +	 "</span>" + " " + getCookie('myStoreAddress') 
      	+ " <br/> " + getCookie('myStorePhone') ;
      
      btn = "<input type='button' style='color:white;' value='Change' class='ymm_yellow_button baseControl' onclick='selectStoreWithRedirect();'>";
      
      
      innerHTML = "<div style='float:left; margin:5px; text-align:left;'>" + storeInfo + "</div>"
      + "<div style='float:right;'>" + btn + "</div>";
      //+ "&nbsp; <input type='button' value='x' class='changeStore' onClick='removeStore();' />"
      
      //+ "<br/><input type='button' value='Change' class='changeStore' onclick=window.top.location.href='" + storePageURL + "';>";

      document.getElementById('desktop_myStore').innerHTML = innerHTML;
      document.getElementById('mobile_myStore').innerHTML =  storeInfo + "<br/>" + btn;
      
      
    }
    catch (err){}
  }
  else{
      document.getElementById('desktop_myStore').innerHTML = "<input type='button' value='Find a Store' class='ymm_yellow_button baseControl padding-11' style='color:white;' onclick='selectStoreWithRedirect();' />"
	  document.getElementById('mobile_myStore').innerHTML = "";
  }
  */
}

function clearStore(){
  setCookie('myStore',"");
  location.reload();
  //setStoreFromCookies();
}

function getSelectedStore(){
  return getCookie('myStore');
}

function getSelectedStoreNumber(){
  if (getCookie('myStore') == "")
    return 0;
  else
  	return getCookie('myStore').slice(-3);
}

function getSelectedStoreAddress(){
  return getCookie('myStoreAddress');
}

// YMM Funtions

function setDefaultValues(){
  baseURL = "https://ps-whi-stage.azurewebsites.net/vehicles";
  yearDD = document.getElementById('ymm_year');
  makeDD = document.getElementById('ymm_make');
  modelDD = document.getElementById('ymm_model');
  trimDD = document.getElementById('ymm_trim');
  engineDD = document.getElementById('ymm_engine');
  
}

function loadMake(){
  
  setDefaultValues();
  
  clearItems('model|trim|engine');
  disableItems('model|trim|engine',true);
  
  var ymm_make = document.getElementById('ymm_make');
  var final_url = baseURL + "/makes";
  //console.log(final_url);	

  fetch(final_url)
  .then(function(response) {
	return response.json();
  })
  .then(function(myJson) {
    //console.log(JSON.stringify(myJson));
    var recs = myJson.data.make.length;
    var option;
    for (i = 0 ; i < recs ; i++){
      option = document.createElement("option");
      option.text = myJson.data.make[i].value;
      option.value = myJson.data.make[i].id;

      ymm_make.add(option);
    }
  });
}

function yearChanged(element){
  yearOrMakeChanged(element);
}

function makeChanged(element){
  yearOrMakeChanged(element);
}

function yearOrMakeChanged(element){
  clearVehicleID();
  clearItems("model|trim|engine");
  
  var yearIndex , makeIndex;
  yearIndex = yearDD.selectedIndex;
  makeIndex = makeDD.selectedIndex;
  if (yearIndex > 0 && makeIndex > 0){
  	//loadModel(element.options[element.selectedIndex].value);
    loadModel(makeDD.options[makeDD.selectedIndex].value);
    
  }
  else{
  	disableItems("model|trim|engine",true);
    
  }
}

function loadModel(makeId){
  clearVehicleID();
  
  var yy = yearDD.value;// document.getElementById('ymm_year').value;
  
  clearItems('model|trim|engine');
  
  if (yy != "Year"){
	//var ymm_model = document.getElementById('ymm_model');
  	
    var final_url = baseURL + "/models/makeid/" + makeId + "/modelyear/" + yy;
    fetch(final_url)
    .then(function(response) {
      return response.json();
    })
    .then(function(myJson) {
      //console.log(JSON.stringify(myJson));
      var recs = myJson.data[0].model.length;
      //alert(recs);
      var option;
      for (i = 0 ; i < recs ; i++){
        option = document.createElement("option");
        option.text = myJson.data[0].model[i].value;
        option.value = myJson.data[0].model[i].id;
        ymm_model.add(option);
      }
      
      // Select the model if there's only one option
      if (recs==1){
      	modelDD.selectedIndex = 1;
        disableItems('trim|engine',true);
        loadTrims();
      }
  	})
    .then(function(){
    	disableItems("trim|engine",true);
    	disableItems("model",false);
    });
  }
}

function modelChanged(element){
  clearItems("trim|engine");
  clearVehicleID();
  if (element.selectedIndex != 0){
    loadTrims();
  	disableItems("trim",false);
  }
  else{
  	disableItems("trim|engine",true);
    
  }
}

function loadTrims(){
 
  clearItems('trim');
  
  var final_url = baseURL + "/trim/makeid/" + makeDD.value + "/modelid/" + modelDD.value + "/modelyear/" + yearDD.value;
  // /basevehicle/makeid/{makeId}/modelid/{modelId}/modelyear/{year}

  fetch(final_url)
  .then(function(response) {
    return response.json();
  })
  .then(function(myJson) {
    //console.log(JSON.stringify(myJson));
    var recs = myJson.data.sub_model.length;
    //alert(recs);
    var option;
    for (i = 0 ; i < recs ; i++){
      option = document.createElement("option");
      option.text = myJson.data.sub_model[i].description;
      option.value = myJson.data.sub_model[i].id;
      ymm_trim.add(option);
    }
    // Select the Trim if there's only one option
      if (recs==1){
      	trimDD.selectedIndex = 1;
        disableItems('trim',true);
        loadEngines();
      }
  });
}

function trimChanged(element){
  clearVehicleID();
  clearItems("engine");

  if (element.selectedIndex!=0){
  	loadEngines();
    disableItems("engine",false);
  }
  else{
  	disableItems("engine",true);
  }
}

function loadEngines(){
  clearVehicleID();
  clearItems('engine');
	  
  var final_url = baseURL + "/basevehicle/makeid/" + makeDD.value + "/modelid/" + modelDD.value + "/modelyear/" + yearDD.value;
  
  fetch(final_url)
  .then(function(response) {
    return response.json();
  })
  .then(function(myJson) {
    console.log(JSON.stringify(myJson));
    return myJson.data.base_vehicle_id;
  })
  .then(function(bID){
  	baseVehicleID = bID ;
    final_url = baseURL + "/engines/basevehicleID/" + bID + "/submodelid/" + trimDD.value;
    // /engines/basevehicleid/{baseVehicleId}
	return fetch(final_url)
  	.then(function(response) {
      return response.json();
  	})
  	.then(function(myJson) {
      console.log(JSON.stringify(myJson));
      var recs = myJson.data.engine.length;
      var option;
      for (i = 0 ; i < recs ; i++){
        option = document.createElement("option");
        option.text = myJson.data.engine[i].value;
        option.value = myJson.data.engine[i].id;
        ymm_engine.add(option);
      }
      // Select the engine if there's only one option
      if (recs==1){
      	engineDD.selectedIndex = 1;
        disableItems('engine',true);
        getFinalVehicleID();
      }
      else{
        disableItems('engine',false);
      }
    });
  }); 
}

function engineChanged(element){
  getFinalVehicleID();

}

function getFinalVehicleID(){
  var trimIndex = trimDD.selectedIndex;
  var engineIndex = engineDD.selectedIndex;
  if (trimIndex > 0 && engineIndex > 0){
    
    var final_url = "https://ps-whi-stage.azurewebsites.net/vehicles/detail/basevehicleid/" + baseVehicleID + "/submodelid/" + trimDD.value + "/engineconfigid/" + engineDD.value;
    fetch(final_url)
    .then(function(response) {
      return response.json();
    })
    .then(function(myJson) {
      //console.log(JSON.stringify(myJson));
      //$("#vehicleID").text(myJson.data.vehicleId);
      $("#vehicleID").text(myJson.data.vehicle_to_engine_config_id);
      $("#vid_browse").attr( "disabled", false );
      $("#vid_browse").css("visibility","visible");
      
      $("#vid_set").attr( "disabled", false );
      $("#vid_set").css("visibility","visible");
      setCookie("temp_vid",myJson.data.vehicle_to_engine_config_id,5);
      //$('#YMM_options').append(myJson.data.vehicleToEngineConfigId + "<br>");
  	});    
    //$("#vehicleID").text("Vehicle ID");
  }
  else{ // hide 'Add button
  	clearVehicleID();
  }
}

function temp_vid(){
  var vid = $("#vehicleID").text();
  window.location.href = "https://partsource.myshopify.com/search?type=product&vid=" + vid;
}

function clearVehicleID(){
  //$("#vehicleID").text("");
  $("#vid_browse").prop( "disabled", true );
  $("#vid_set").prop( "disabled", true );
  //$("#vid_search").fadeOut();
  $("#vid_browse").attr('disabled', true);
  $("#vid_set").attr('disabled', true);
}

function clearItems(selectList){
  var lists = selectList.split("|");
  for (i = 0 ; i < lists.length; i++){
  	var thisDD = document.getElementById('ymm_' + lists[i]);
    while (thisDD.length > 1 ){
      thisDD.remove(1);
    }
  }
}

function disableItems(selectList, isDisabled){
  var lists = selectList.split("|");
  for (i = 0 ; i < lists.length; i++){
  	var dd = document.getElementById('ymm_' + lists[i]);
    dd.disabled=isDisabled;
    if (isDisabled){
      dd.style.backgroundColor = '#e7e7e7';
      dd.style.Color = '#999';
    }
    else
    {
      dd.style.backgroundColor = '#fff';
      dd.style.Color = '#000';
    }
  }
}

// Cookies Base Functions

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	
  /*$.cookie(cname, cvalue, {
   expires : expires,           // Expires in 10 days

   path    : '/',          // The value of the path attribute of the cookie
                           // (Default: path of page that created the cookie).

   domain  : 'jquery.com', // The value of the domain attribute of the cookie
                           // (Default: domain of page that created the cookie).

   secure  : true          // If set to true the secure attribute of the cookie
                           // will be set and the cookie transmission will
                           // require a secure protocol (defaults to false).
	});
	*/
}


function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return ""; 
  //return $.cookie(cname);
}

function deleteCookie(cname){
  document.cookie = cname + "= ; expires=Thu, 18 Dec 2013 12:00:00 UTC";
}

async function getAvailability(SKU, isPDP) {
  let strSKU = SKU.toString().padStart(7, '0');
  const store = parseInt(getSelectedStoreNumber());
  const divID = isPDP ? 'part_Availability' : `part_Availability_${strSKU}`;
  const myDiv = document.getElementById(divID);

  if (store === 0) {
    if (!isPDP) {
      myDiv.style.display = "none";
    }
    return;
  }

  const url = `https://ps-whi-stage.azurewebsites.net/inventory/sku/${strSKU}/storenumber/${store}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    const qty = parseInt(data.data.quantity);
    //const times = data.data.updated
    
    if (qty > 0) {
      myDiv.className = "baseBlock partAvailable";
      //myDiv.innerHTML = `<span class='availabilityText'><span class='checkMark'>&#10004; </span> ${qty} Available at your store <br><font size="2"> &emsp;&emsp;&emsp;&emsp; As of: ${times}</font></span>`;
      myDiv.innerHTML = `<span class='availabilityText'><span class='checkMark'>&#10004; </span> ${qty} Available at your store </span>`;
   
      if (isPDP) {
        let options = "";
        for (let x = 1; x <= qty && x <= maxOrderQty; x++) {
          options += `<option>${x}</option>`;
        }
        
        $('#ps_cartQty').empty().append(options);
        $('.product-form--atc').show();
      }
    } else {
      handleUnavailable(myDiv, isPDP);
    }
  } catch (error) {
    console.error('Error fetching availability:', error);
    handleUnavailable(myDiv, isPDP);
  }
}

function handleUnavailable(myDiv, isPDP) {
  const imagePath = "https://cdn.shopify.com/s/files/1/2239/4255/files/notAvailable.png?1443909214120361022";
  
  myDiv.className = "baseBlock partUnavailable";
  myDiv.innerHTML = "<span class='availabilityText'><span class='crossMark' style='background-color:orange; color:white; font-weight:bold;'> !</span> Please Call Store For Availability </span>";
  
  if ($('#isLeerCover').html().indexOf("true") >= 0) {
    $('.product-form--atc').show();
    myDiv.innerHTML = "<span class='availabilityText'><span class='crossMark' style='background-color:orange;'>!</span> Special Order. Store to confirm delivery date.</span>";
  } else {
    $('.product-form--atc').hide();
  }
}


function getCartAvailability(SKU){
  /*
  var strSKU = SKU.trim() + '';
  while (strSKU.length < 7) 
    strSKU = '0' + strSKU;

  var q;
  var obj;
  var url;
  
  var store = parseInt(getSelectedStoreNumber());
  
  var dropdown = document.getElementById('qty_' + SKU);
  
  url = 'http://ps-whi-stage.azurewebsites.net/inventory/sku/' + strSKU + '/storenumber/' + store;

  // FETCH
  fetch(url)
  .then(res => res.json())
  .then(data => obj = data)
  //.then(obj => document.getElementById('partAvailability').innerHTML = obj.data.Quantity)
  .then(obj => qty = obj.data.quantity)
  //.then(() => console.log(obj))
  //.then(() => console.log(qty))
  .then(function() {
    var imagePath= ""; 
    q = parseInt(qty);
    if (q > 0){
      // set max order qty
	  var origVal = $(dropdown).find(":selected").text();
      var options = "";
      
      for (x=1; x <=q && x <= maxOrderQty; x++){
        options = options + "<option";
        if (x == origVal){
        	options = options + " selected "
        }
        options = options + ">" + x + "</option>";
      }
      //alert($( '#qty_' + SKU + ':selected' ).text());
      //$(dropdown)
      //.empty()
      //.append(options)
      //;
    }
  }).catch(function(){

  });
  */
}

async function getAllAvailabilities(elementID, SKU){
  //alert(elementID + " | " + SKU);

  var strSKU = SKU.trim() + "";
  while (strSKU.length < 7) 
    strSKU = "0" + strSKU;

  var q;
  var obj;
  var url;

  var allStores = getStoreNumbers(false).split(","); // false indicates we are looking for all stores

  //alert(allStores);

  let tempStoreQty = [];

  for (let i=0; i< allStores.length; i++){
    try{
      var fetched = false;

      var store = parseInt(allStores[i]);

      let url = 'http://ps-whi-stage.azurewebsites.net/inventory/sku/' + strSKU + '/storenumber/' + store;

      const response = await fetch(url);
      const json = await response.json();
      const  q = await json.data.quantity;
      
      tempStoreQty.push(store + ":" + q);
	
      let html = await $('#' + elementID).html();

      //document.getElementById('#' + elementID) = await html + store + ":" + q + "|"
      $('#' + elementID).html(html + store + ":" + q + "|");
    }catch(err){}
    
  }  // for loop for each store
}// function end

async function getQtyForStore(store, SKU){
  //alert(elementID + " | " + SKU);

  var strSKU = SKU.trim() + "";
  while (strSKU.length < 7) 
    strSKU = "0" + strSKU;

  var q;
  var obj;
  var url;

  try{
    let url = 'http://ps-whi-stage.azurewebsites.net/inventory/sku/' + strSKU + '/storenumber/' + store;

    const response = await fetch(url);
    const json = await response.json();
    const  q = await json.data.quantity;

    let html = await $('#' + elementID).html();
	return q;
    //document.getElementById('#' + elementID) = await html + store + ":" + q + "|"
    //$('#' + elementID).html(html + store + ":" + q + "|");
  }catch(err){}

}

/*
async function getAvailQty2 (strSKU, store) {
  var url = 'http://ps-whi-stage.azurewebsites.net/inventory/sku/0162237/storenumber/732';
	var q = -1;
  	var qty;
    var obj;
  
  try {
    const resp = await fetch(url)
    console.log(resp)
    return resp
  } catch (err) {
    console.log(err)
  }
}

function getAvailQty(strSKU, store){
	var url = 'http://ps-whi-stage.azurewebsites.net/inventory/sku/' + strSKU + '/storenumber/' + store;
	var q = -1;
  	var qty;
    var obj;
  
  	
  
    // FETCH
    fetch(url)
    .then(res => res.json())
    .then(data => obj = data)
    //.then(obj => document.getElementById('partAvailability').innerHTML = obj.data.Quantity)
    .then(obj => qty = obj.data.quantity)
    .then(() => console.log(obj))
    .then(() => console.log(qty))
    .then(() => console.log("test 2"))
    .then(function() {
      console.log("Before Parse : " + q); 
      q = parseInt(qty);
      console.log("After Parse : " + q); 
    })
    .then(function(){
    	
    })
     .catch( err => {
    err.text().then( errorMessage => {
      alert(errorMessage);
    })
  });
  console.log("After fetch "); 
  return q;
}

*/

function selectStoreWithRedirect(){
  setCookie('redirectURL',window.location.href);
  window.top.location.href = "https://partsource.myshopify.com/apps/store-locator/";
}

function addToSearchVID(){
  console.log('add term to search');
}

function temp_qs(key,val){
  console.log(key + ":" + val);
}


function updateVariantInfo(dropdown){
  /*var values = dropdown.options[dropdown.selectedIndex].value.split('|');
  
  var price = parseFloat(values[2])/100;
  var compPrice = parseFloat(values[1])/100;
  
  //alert($('#customProductSKU').text());
  $('#customProductSKU').html("<strong>SKU </strong>" + values[0]);
  getAvailability(values[0],true); // true indicates that we calling this from PDP, and there are variants available
  if (price == compPrice){
    $('#productPrice').html("$" + price);
  }
  else{
    $('#productPrice').html("<span style='text-decoration: line-through;'>$" + compPrice + "</span> <span style='color:red;'> $" + price + "</span>");
  }*/
}

function triggerCollapsibleFitment(){
  collapseFitment = true;
}

function setCollapsibleFitment(){
  /*$('#thisPartFits').css('height','150px');
  $('#thisPartFits').css('overflow','hidden');
  $('#thisPartFits').css('border','solid 1px #999');*/
  $('#thisPartFits').addClass("collapsibleFitment");
  //$('#partFitmentContainer').append("<input id='toggleShowMore' type='button' style='border-radius:0px 0px 7px 7px; border:solid 1px #ccc; background-color:#eee; padding:3px; box-shadow:none;' value = '&#x25B2; &nbsp; &#x25BC;' onclick='toggleFitmentCollapse()'/>");
  $('#partFitmentContainer').append("<input id='toggleShowMore' type='button' style=' padding:3px; width:100%; color:black; text-align:center;' value = '&#x25B2; &nbsp; &#x25BC;' onclick='toggleFitmentCollapse()'/>");
}

function toggleFitmentCollapse(){
  $('#thisPartFits').toggleClass("collapsibleFitment");
  $('#toggleShowMore').blur();
  /*
  if ($('#toggleShowMore').text() == "Show More"){
  	$('#toggleShowMore').text("Show Less");
  }
  else{
    $('#toggleShowMore').text("Show More");
  }
  */
}

function emailToSignupPage(){
  // Validate Email
  var email = $('#footerSignupEmail').val();
  //alert($('#footerSignupEmail').val());
  // Redirect to sign up page
  window.location.href = "https://www.partsource.ca/pages/email_signup?email=" + email;
  return false;
  
}

